import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div({
    margin: -5,
});

export const IconWrapper = styled.span<{ filtered: boolean }>(props => ({
    display: "inline-block",
    color: props.filtered ? theme(props).typography.primary.color : undefined,
}));

export const Head = styled.div<{ opened: boolean }>(props => ({
    padding: 5,
    backgroundColor: props.opened ? theme(props).menu.hoveredBackgroundColor : undefined,

    "&:hover": {
        backgroundColor: theme(props).menu.hoveredBackgroundColor,
        borderRadius: 2,
        cursor: "pointer",
    },
}));

export const ChildItem = styled.div({
    margin: "15px 20px",
});
